export const basename = (path) => path.replace(/.*\//, '');

export const dirname = (path) => path.match(/.*\//);
